export default __webpack_public_path__ + "static/media/IMG-20220413-WA0018@2x.49e8ee87.webp";